export interface TransformationRow {
  n: string;
  title: string;
  before: string;
  after: string;
}

export const transformationRows: TransformationRow[] = [
  {
    n: '1/5',
    title: 'Preparación',
    before: 'Preparas el entrenamiento a última hora, reuniendo ejercicios de diferentes sitios.',
    after: 'Partes de una sesión organizada y la ajustas al objetivo de tu equipo.'
  },
  {
    n: '2/5',
    title: 'Variedad',
    before: 'Repites los mismos rondos y tareas porque no tienes tiempo para buscar alternativas.',
    after: 'Consultas variantes y progresiones para trabajar objetivos concretos.'
  },
  {
    n: '3/5',
    title: 'Transferencia',
    before: 'Tus jugadores realizan ejercicios, pero no siempre consigues trasladarlos al partido.',
    after: 'Trabajas situaciones conectadas con el juego real.'
  },
  {
    n: '4/5',
    title: 'Corrección',
    before: 'Te cuesta identificar qué corregir cuando una tarea no funciona.',
    after: 'Consultas errores frecuentes, correcciones y opciones para adaptar el ejercicio.'
  },
  {
    n: '5/5',
    title: 'Tiempo',
    before: 'Dedicas parte de tu tiempo libre a planificar desde cero.',
    after: 'Utilizas una base de trabajo para preparar tus próximas sesiones.'
  }
];

export interface TransformationFooterStat {
  value: string;
  label: string;
}

export const transformationFooterStats: TransformationFooterStat[] = [
  { value: '+120h', label: 'Ahorradas al año' },
  { value: '2 clics', label: 'Para cada sesión lista' },
  { value: '100%', label: 'Profesional' }
];
